import React from 'react';
import Button from '../ui/Button';

const FinalCTA: React.FC = () => {
  const sectionStyle: React.CSSProperties = {
    padding: '12rem 0',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const titleStyle: React.CSSProperties = {
    marginBottom: '2rem',
    maxWidth: '800px',
    marginLeft: 'auto',
    marginRight: 'auto',
  };

  const buttonGroupStyle: React.CSSProperties = {
    display: 'flex',
    gap: '1rem',
    justifyContent: 'center',
    marginTop: '2rem',
  };

  return (
    <section style={sectionStyle}>
      <div className="container">
        <span className="mono-label">Get Started</span>
        <h2 style={titleStyle}>
          Upload your first file.
        </h2>
        <p style={{ margin: '0 auto', maxWidth: '500px' }}>
          Start with a CSV or Excel file. GabMic will show only analytics grounded in the data you upload.
        </p>
        
        <div style={buttonGroupStyle}>
          <a href="/signup">
            <Button variant="primary" size="lg">
              Create Account
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
